import React, { useEffect, useState } from "react";

import AnimatedDiv from "src/app/components/AnimatedDiv/AnimatedDiv";
import { ModalTitle } from "src/app/components/Modal/Modal";
import IDHFormattedMessage from "src/app/components/IDHFormattedMessage/IDHFormattedMessage";
import { SettingsButtons } from "../../components/SettingsTabContent/SettingsTabContent";
import { Button } from "src/app/components/Button/Button";
import { ReactComponent as ShareIcon } from "src/images/share-alt.svg";

import "./Subscription.scss";
import OuterLink from "src/app/components/OuterLink/OuterLink";
import { useSelector } from "react-redux";
import { RootState } from "src/redux/reducers";
import axios from "axios";
import { API_URLS } from "src/utils/API_URLS";

enum SubscriptionTabs {
  Plan = "plan",
  Billing = "billing",
}

interface Props {
  onClose: () => void;
}

function Subscription(props: Props) {
  const { onClose } = props;

  const { activeWorkspaceUuid } = useSelector(
    (state: RootState) => state.mainReducer,
  );
  const { subscriptionPlan } = useSelector(
    (state: RootState) => state.subscriptionReducer,
  );

  const [activeTab, setActiveTab] = useState<SubscriptionTabs>(
    SubscriptionTabs.Plan,
  );
  const [buttonLink, setButtonLink] = useState(null);

  const getCustomerPortalEndpoint = async () => {
    return API_URLS.getCustomerPortalLink
      .replace(":workspaceUuid:", activeWorkspaceUuid)
      .replace(":returnUrl:", window.location.href);
  };

  const getCheckoutSessionEndpoint = async () => {
    return API_URLS.getCheckoutSessionLink
      .replace(":workspaceUuid:", activeWorkspaceUuid)
      .replace(":successUrl:", window.location.href);
  };

  const getEndpoint = () => {
    if (subscriptionPlan?.isPaymentMethodSet) {
      return getCustomerPortalEndpoint();
    } else {
      return getCheckoutSessionEndpoint();
    }
  };

  const generateButtonLink = async () => {
    const endpoint = await getEndpoint();

    const {
      data: { content },
    } = await axios.get(endpoint);
    setButtonLink(content.url);
  };

  useEffect(() => {
    if (!subscriptionPlan?.isCustomerStripe) {
      setButtonLink(null);
      return;
    }

    generateButtonLink();
  }, [subscriptionPlan]);

  const renderButton = () => {
    if (!buttonLink) return null;

    return (
      <OuterLink href={buttonLink}>
        <Button variant="blue" size="large" className="subscription__button">
          {subscriptionPlan?.isPaymentMethodSet ? (
            <IDHFormattedMessage
              id="ws_manage_subscription"
              defaultMessage="Manage subscription"
            />
          ) : (
            <IDHFormattedMessage
              id="ws_add_payment_method"
              defaultMessage="Add payment method"
            />
          )}
          <ShareIcon />
        </Button>
      </OuterLink>
    );
  };

  // const renderTabContent = () => {
  //   switch (activeTab) {
  //     case SubscriptionTabs.Billing:
  //       return <Billing />;

  //     case SubscriptionTabs.Plan:
  //       return <Plan />;
  //   }
  // };

  return (
    <>
      <AnimatedDiv className="subscription">
        <div className="subscription__title-wrapper">
          <ModalTitle>
            <IDHFormattedMessage
              id="ws_subscription"
              defaultMessage="Subscription"
            />
          </ModalTitle>
        </div>

        {renderButton()}

        {/* <Tabs>
          <Tab
            active={activeTab === SubscriptionTabs.Plan}
            tabText={<IDHFormattedMessage id="ws_plan" defaultMessage="Plan" />}
            onClick={() => setActiveTab(SubscriptionTabs.Plan)}
          />
          <Tab
            active={activeTab === SubscriptionTabs.Billing}
            tabText={
              <IDHFormattedMessage id="ws_billing" defaultMessage="Billing" />
            }
            onClick={() => setActiveTab(SubscriptionTabs.Billing)}
          />
        </Tabs> */}

        {/* {renderTabContent()} */}
      </AnimatedDiv>

      <SettingsButtons onClose={onClose} />
    </>
  );
}

export default Subscription;
